module.exports = __webpack_public_path__ + "img/10.c51692a.png";